<template>
  <div>
    <TxBtn
      class="rule-btn"
      :src="btn_src"
      name="网页疑问"
      @click="is_show = true"
    ></TxBtn>

    <TxDialog v-model="is_show" zIndex="10001" class="dialog-box">
      <TxBg :src="dlg_src" class="rule">
        <div class="rule-header" v-if="title != undefined">{{ title }}</div>
        <div v-for="(item, index) in rule_content" :key="index">
          <div class="rule-title">{{ index + 1 }}.{{ item.title }}</div>
          <div class="rule-content">
            {{ item.content }}
          </div>
        </div>
      </TxBg>
    </TxDialog>
  </div>
</template>


<script setup>

const props = defineProps({
  btn_src:{
    type: String,
    default: 'wangyeyiwen',
  },
  dlg_src:{
    type: String,
    default: 'popoup_wangyeyiwen-di',
  },  
  title:{
    type: String,
  }
})

const is_show = ref(false);

const rule_content = ref([
  {
    title: '英雄榜是什么？',
    content:
      '英雄榜是《天下3》游戏信息查询工具，定时从游戏服务器提取数据，通过网页呈现给用户。英雄榜所有数据来源于真实游戏服务器，展示《天下3》游戏中的全部角色装备信息、角色技能、属性排名等，是权威的官方数据。',
  },
  {
    title: '我能在英雄榜上查找什么？',
    content:
      '在搜索栏输入角色昵称搜索，并在搜索结果中选择进入角色展示页，可查询到角色的装备、技能、属性、排名信息。',
  },
  //   {
  //     title: '英雄榜推荐和支持的浏览器有哪些？',
  //     content: `英雄榜目前支持几乎所有的主流浏览器，包括：
  // Firefox3.0+
  // IE6, IE7, IE8
  // Google-Chrome
  // Opera
  // Safari
  // 为了能更流畅的体验英雄榜，推荐你使用Firefox、Chrome以及IE7以上版本的浏览器。`,
  //   },
  {
    title: '为什么我的角色信息不显示？',
    content:
      '英雄榜只显示活跃角色的信息，只有20级及以上的角色才会显示角色属性表。',
  },
  {
    title: '为什么我找不到自己的低级角色？',
    content: '只有20级以上角色才会进入英雄榜，包括角色信息及角色名称检索结果。',
  },
]);
</script>

<style lang="scss" scoped>

.rule-header{
  width: 200px;
  height: 40px;
  position: absolute;
  left: 48px;
  top: 80px;
  font-size: 24px;
  
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
